import { render, staticRenderFns } from "./ClinicIncomeReport.vue?vue&type=template&id=0a1c34cd&scoped=true"
import script from "./ClinicIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c34cd",
  null
  
)

export default component.exports